'use strict';

var App = require('app');
var Consts = require('consts');
var AbstractFormView = require('components/common/views/abstract_form_view');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');

var UserTransferDialogView = AbstractFormView.extend({
    template: require('components/devices/templates/common/user_transfer'),

    events: function () {
        return _.extend({}, AbstractFormView.prototype.events, {
            'click button#js-save': 'validateForm',
        });
    },

    initialize: function (options) {
        this.options = options;
        this.model = options.model;
        this.controller = options.controller;

        AbstractFormView.prototype.initialize.apply(this, [
            {
                formData: options.model ? options.model.toJSON() : {},
                inputFields: {
                    email: {
                        method: 'email',
                        validIfNotVisible: true,
                    },
                },
            },
        ]);
    },

    validateForm: function (e) {
        e.preventDefault();
        var self = this;

        if (this.allFieldsValid()) {
            var form = Backbone.Syphon.serialize(this);

            Decorator.disableElement('.modal-dialog');
            this.options.transfer_cb({
                email: form.email,
                success: function () {
                    App.hideModal();
                    Notification.show(
                        'success',
                        i18n.TR('Erfolg'),
                        i18n.TR('E-Mail zur Bestätigung der Geräteübertragung wurde versendet.')
                    );
                },
                error: function (errors) {
                    self.errors = errors;
                    self.formData = form;
                    App.refreshModal(self);
                },
            });
        }
    },
});

module.exports = UserTransferDialogView;
